"use strict";

var _classCallCheck = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _require = require("../helpers/internal-constants"),
    domSymbolTree = _require.domSymbolTree;

var _require2 = require("../helpers/namespaces"),
    SVG_NS = _require2.SVG_NS;

var _require3 = require("../../utils"),
    mixin = _require3.mixin;

var SVGAnimatedString = require("../generated/SVGAnimatedString");

var ElementImpl = require("./Element-impl").implementation;

var ElementCSSInlineStyleImpl = require("./ElementCSSInlineStyle-impl").implementation;

var GlobalEventHandlersImpl = require("./GlobalEventHandlers-impl").implementation;

var HTMLOrSVGElementImpl = require("./HTMLOrSVGElement-impl").implementation;

var SVGElementImpl =
/*#__PURE__*/
function (_ElementImpl) {
  _inherits(SVGElementImpl, _ElementImpl);

  function SVGElementImpl(args, privateData) {
    var _this;

    _classCallCheck(this, SVGElementImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SVGElementImpl).call(this, args, privateData));

    _this._initHTMLOrSVGElement();

    _this._initElementCSSInlineStyle();

    _this._initGlobalEvents();

    return _this;
  } // Keep in sync with HTMLElement. https://github.com/jsdom/jsdom/issues/2599


  _createClass(SVGElementImpl, [{
    key: "_attrModified",
    value: function _attrModified(name, value, oldValue) {
      if (name === "style" && value !== oldValue && !this._settingCssText) {
        this._settingCssText = true;
        this._style.cssText = value;
        this._settingCssText = false;
      } else if (name.startsWith("on")) {
        this._globalEventChanged(name.substring(2));
      }

      _get(_getPrototypeOf(SVGElementImpl.prototype), "_attrModified", this).apply(this, arguments);
    }
  }, {
    key: "className",
    get: function get() {
      return SVGAnimatedString.createImpl([], {
        element: this,
        attribute: "class"
      });
    }
  }, {
    key: "ownerSVGElement",
    get: function get() {
      var e = domSymbolTree.parent(this);

      while (e && e.namespaceURI === SVG_NS) {
        if (e.localName === "svg") {
          return e;
        }

        e = domSymbolTree.parent(e);
      }

      return null;
    }
  }, {
    key: "viewportElement",
    get: function get() {
      // TODO: <symbol>/<use> may make this different from ownerSVGElement.
      return this.ownerSVGElement;
    }
  }]);

  return SVGElementImpl;
}(ElementImpl);

SVGElementImpl.attributeRegistry = new Map();
mixin(SVGElementImpl.prototype, ElementCSSInlineStyleImpl.prototype);
mixin(SVGElementImpl.prototype, GlobalEventHandlersImpl.prototype);
mixin(SVGElementImpl.prototype, HTMLOrSVGElementImpl.prototype);
exports.implementation = SVGElementImpl;